//Jquery
import "./jquery-global.js";
import $ from "jquery";
import "vanilla-cookieconsent";

export function initiateCookieConsent() {

    let cc = initCookieConsent();
    let cookieTemplate = $('#cookie-consent-template');
    if (cookieTemplate.length) {
        cookieTemplate = JSON.parse(cookieTemplate.html().trim());
    } else {
        //set default values
        cookieTemplate = {
        consentModalDescription: 'Hi, this website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only after consent. <button type="button" data-cc="c-settings" class="cc-link">Let me choose</button>',
        consentModalTitle: 'We use cookies!',
        moreInformationDescription: `For any queries in relation to our policy on cookies and your choices, please <a class="cc-link" href="/contact-us">contact us</a>.`,
        moreInformationTitle:
            "More information",
        settingsModalDescription: 'I use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want. For more details relative to cookies and other sensitive data, please read the full <a href="/privacy-policy" class="cc-link">privacy policy</a>.',
        settingsModalTitle: "Cookie usage 📢"
        };
    }
    
    cc.run({
        current_lang: 'en',
        autoclear_cookies: true,
        page_scripts: true,
        // revision: 0,
        gui_options: {
            consent_modal: {
                layout: 'cloud',
                position: 'middle center',
                transition: 'slide',
                swap_buttons: false
            },
            settings_modal: {
                layout: 'box',
                transition: 'slide'
            }
        },
        languages: {
            'en': {
                consent_modal: {
                    title: cookieTemplate.consentModalTitle,
                    description: cookieTemplate.consentModalDescription,
                    primary_btn: {
                        text: 'Accept all',
                        role: 'accept_all'
                    },
                    secondary_btn: {
                        text: 'Reject all',
                        role: 'accept_necessary'
                    }
                },
                settings_modal: {
                    title: 'Cookie preferences',
                    save_settings_btn: 'Save settings',
                    accept_all_btn: 'Accept all',
                    reject_all_btn: 'Reject all',
                    close_btn_label: 'Close',
                    cookie_table_headers: [
                        {col1: 'Name'},
                        {col2: 'Domain'},
                        {col3: 'Expiration'},
                        {col4: 'Description'}
                    ],
                    blocks: [
                        {
                            title: cookieTemplate.settingsModalTitle,
                            description: cookieTemplate.settingsModalDescription
                        }, {
                            title: 'Strictly necessary cookies',
                            description: 'These cookies are essential for the proper functioning of my website. Without these cookies, the website would not work properly',
                            toggle: {
                                value: 'necessary',
                                enabled: true,
                                readonly: true
                            },
                            cookie_table: [
                                {
                                    col1: 'ARRAffinity',
                                    col2: '/',
                                    col3: 'ARRAffinity cookie is set by Azure app service, and allows the service to choose the right instance established by a user to deliver subsequent requests made by that user.',
                                    col4: 'session'
                                },
                                {
                                    col1: 'ARRAffinitySameSite',
                                    col2: '/',
                                    col3: 'This cookie is set by Windows Azure cloud, and is used for load balancing to make sure the visitor page requests are routed to the same server in any browsing session.',
                                    col4: 'session'
                                },
                                {
                                    col1: '.AspNetCore.Antiforgery.^',
                                    col2: '/',
                                    col3: 'No description.',
                                    col4: 'Helps prevent Cross-Site Request Forgery (CSRF) attacks.',
                                    is_regex: true
                                },
                                {
                                    col1: 'RequestVerificationToken',
                                    col2: '/',
                                    col3: 'No description.',
                                    col4: 'session'
                                },
                                {
                                    col1: 'current.usersessionGuid',
                                    col2: '/',
                                    col3: 'No description.',
                                    col4: '3 months'
                                },
                                {
                                    col1: 'CookieConsent',
                                    col2: '/',
                                    col3: 'Stores the user\'s cookie consent state for the current domain',
                                    col4: '1 year'
                                },
                                {
                                    col1: 'alert-bar-update',
                                    col2: '/',
                                    col3: 'Stores the latest read alert state for the current domain',
                                    col4: '1 year'
                                }
                            ]
                        }, {
                            title: 'Performance and Analytics cookies',
                            description: 'These cookies allow the website to remember the choices you have made in the past',
                            toggle: {
                                value: 'analytics',
                                enabled: false,
                                readonly: false
                            },
                            cookie_table: [
                                {
                                    col1: 'ai_user',
                                    col2: '/',
                                    col3: '1 year',
                                    col4: 'A unique user identifier cookie, set by Microsoft Application Insights software, that enables counting of the number of users accessing the application over time.',
                                },
                                {
                                    col1: 'ai_session',
                                    col2: '/',
                                    col3: '30 minutes',
                                    col4: 'This is a unique anonymous session identifier cookie set by Microsoft Application Insights software to gather statistical usage and telemetry data for apps built on the Azure cloud platform.',
                                },
                                {
                                    col1: 'AI_sentBuffer',
                                    col2: '/',
                                    col3: 'Session',
                                    col4: 'Used in context with the &quot;AI_buffer&quot; in order to limit the number of data-server-updates (Azure). This synergy also allows the website to detect any duplicate data-server-updates.',
                                },
                                {
                                    col1: 'AI_buffer',
                                    col2: '/',
                                    col3: 'Session',
                                    col4: 'Used in context with the &quot;AI_sentBuffer&quot; in order to limit the number of data-server-updates (Azure).  This synergy also allows the website to detect any duplicate data-server-updates.',
                                },
                                {
                                    col1: '_ga',
                                    col2: '.google.com',
                                    col3: '2 years',
                                    col4: 'Used to distinguish users.'
                                },
                                {
                                    col1: '_ga_^',
                                    col2: '.google.com',
                                    col3: '2 years',
                                    col4: 'Used to persist session state.',
                                    is_regex: true
                                },
                                {
                                    col1: '_gid',
                                    col2: '.google.com',
                                    col3: '24 hours',
                                    col4: 'Used to distinguish users.'
                                },
                                {
                                    col1: '_gat',
                                    col2: '.google.com',
                                    col3: '1 minute',
                                    col4: `Used to throttle request rate. If Google Analytics is deployed via
      Google Tag Manager, this cookie will be named <code translate="no" dir="ltr">_<wbr>dc_<wbr>gtm_<wbr>&lt;property-
      id&gt;</code>.`
                                },
                                {
                                    col1: 'AMP_TOKEN',
                                    col2: '.google.com',
                                    col3: '30 seconds to 1 year',
                                    col4: 'Contains a token that can be used to retrieve a Client ID from AMP Client ID service. Other possible values indicate opt-out, inflight request or an error retrieving a Client ID from AMP Client ID service.'
                                },
                                {
                                    col1: '_gac_^',
                                    col2: '.google.com',
                                    col3: '90 days',
                                    col4: `Contains campaign related information for the user. If you have
      linked your Google Analytics and Google Ads accounts, Google Ads
      website conversion tags will read this cookie unless you opt-out.
      <a href="//support.google.com/google-ads/answer/7521212">Learn more about How Google Ads tracks website conversions</a>.`,
                                    is_regex: true
                                },
                                {
                                    col1: '_hjSessionUser_{site_id}',
                                    col2: "/",
                                    col3: '365 days',
                                    col4: `Set when a user first lands on a page.
Persists the Hotjar User ID which is unique to that site. Hotjar does not track users across different sites.
Ensures data from subsequent visits to the same site are attributed to the same user ID.
365 days duration.
JSON data type.`,
                                },
                                {
                                    col1: '_hjHasCachedUserAttributes',
                                    col2: "/",
                                    col3: 'Session',
                                    col4: `Enables us to know whether the data set in _hjUserAttributes Local Storage item is up to date or not.
Session duration.
Boolean true/false data type.`,
                                },
                                {
                                    col1: '_hjUserAttributesHash',
                                    col2: '/',
                                    col3: '2 minutes',
                                    col4: `Enables us to know when any User Attribute has changed and needs to be updated.
2 minutes duration, extended every 30 seconds.
Content hash data type.`,
                                },
                                {
                                    col1: '_hjUserAttributes',
                                    col2: '/',
                                    col3: 'No explicit expiration',
                                    col4: `Stores User Attributes sent through the Hotjar Identify API.
No explicit expiration.
Base64 encoded JSON data type.`,
                                },
                                {
                                    col1: 'hjViewportId',
                                    col2: '/',
                                    col3: 'Session',
                                    col4: `Stores user viewport details such as size and dimensions.
Session duration.
UUID data type.`,
                                },
                                {
                                    col1: 'hjActiveViewportIds',
                                    col2: '/',
                                    col3: 'No explicit expiration',
                                    col4: `Stores user active viewports IDs.
Stores an expirationTimestamp that is used to validate active viewports on script initialization.
JSON data type.`,
                                },
                                {
                                    col1: '_hjSession_{site_id}',
                                    col2: '/',
                                    col3: '30 minutes',
                                    col4: `Holds current session data.
Ensures subsequent requests in the session window are attributed to the same session.
30 minutes duration, extended on user activity.
JSON data type.`,
                                },
                                {
                                    col1: '_hjCookieTest',
                                    col2: '/',
                                    col3: 'Under 100ms',
                                    col4: `Checks to see if the Hotjar Tracking Code can use cookies. If it can, a value of 1 is set.
Deleted almost immediately after it is created.
Under 100ms duration, cookie expiration time set to session duration.
Boolean true/false data type.`,
                                },
                                {
                                    col1: '_hjLocalStorageTest',
                                    col2: '/',
                                    col3: 'Under 100ms',
                                    col4: `Checks if the Hotjar Tracking Code can use Local Storage.
If it can, a value of 1 is set.
Data stored in _hjLocalStorageTest has no expiration time, but it is deleted almost immediately after it is created.
Under 100ms duration.
Boolean true/false data type.`,
                                },
                                {
                                    col1: '_hjSessionStorageTest',
                                    col2: '/',
                                    col3: 'Under 100ms',
                                    col4: `Checks if the Hotjar Tracking Code can use Session Storage. If it can, a value of 1 is set.
Data stored in _hjSessionStorageTest has no expiration time, but it is deleted almost immediately after it is created.
Under 100ms duration.
Boolean true/false data type.`,
                                },
                                {
                                    col1: '_hjTLDTest',
                                    col2: '/',
                                    col3: 'Session',
                                    col4: `We try to store the _hjTLDTest cookie for different URL substring alternatives until it fails.
Enables us to try to determine the most generic cookie path to use, instead of page hostname.
It means that cookies can be shared across subdomains (where applicable).
After this check, the cookie is removed.
Session duration.
Boolean true/false data type.`,
                                },
                                {
                                    col1: '_hjClosedSurveyInvites',
                                    col2: '/',
                                    col3: '365 days',
                                    col4: `Set when a user interacts with a Link Survey invitation modal.
Ensures the same invite does not reappear if it has already been shown.
365 days duration.
List of Survey IDs, URL encoded.`,
                                },
                                {
                                    col1: '_hjDonePolls',
                                    col2: '/',
                                    col3: '365 days',
                                    col4: `Set when a user completes an on-site Survey.
Ensures the same Survey does not reappear if it has already been filled in.
365 days duration.
List of Survey IDs, URL encoded.`,
                                },
                                {
                                    col1: '_hjMinimizedPolls',
                                    col2: '/',
                                    col3: '365 days',
                                    col4: `Set when a user minimizes an on-site Survey.
                                    Ensures that the Survey stays minimized when the user navigates through your site.
                                    365 days duration.
                                    List of Survey IDs, URL encoded.`,
                                },
                                {
                                    col1: '_hjShownFeedbackMessage',
                                    col2: '/',
                                    col3: '1 day',
                                    col4: `Set when a user minimizes or completes a Feedback widget.
Ensures the Feedback widget will load as minimized if the user navigates to another page where it is set to show.
One day duration.
Boolean true/false data type.`,
                                }
                            ]
                        }, {
                            title: 'Advertisement and Targeting cookies',
                            description: 'These cookies collect information about how you use the website, which pages you visited and which links you clicked on. All of the data is anonymized and cannot be used to identify you',
                            toggle: {
                                value: 'targeting',
                                enabled: false,
                                readonly: false
                            }
                        },
                        {
                            title: cookieTemplate.moreInformationTitle,
                            description: cookieTemplate.moreInformationDescription,
                        }
                    ]
                }
            }

        }
    });
}